import { ReferenceCustomer } from "../../schema/icp";

/**
 * The distinct kinds of company among the lookalike seeds (PREC-3896).
 *
 * The API decides *whether* the list is mixed (it owns the extraction that read
 * the kinds); this only renders which ones it saw, so the warning can name them
 * instead of saying "these are different" and leaving the user to guess which
 * chip is the odd one out. Comparison is by lower-cased text, and the first
 * spelling wins, so "HR software vendor" and "hr Software Vendor" read as one.
 */
export const distinctSeedKinds = (seeds: ReferenceCustomer[]): string[] => {
	const seen = new Map<string, string>();

	for (const seed of seeds) {
		const kind = seed.kind?.trim();

		if (kind && !seen.has(kind.toLowerCase())) {
			seen.set(kind.toLowerCase(), kind);
		}
	}

	return [...seen.values()];
};
